import { render, staticRenderFns } from "./gameChart.vue?vue&type=template&id=2a82f9a6&"
import script from "./gameChart.vue?vue&type=script&lang=js&"
export * from "./gameChart.vue?vue&type=script&lang=js&"
import style0 from "./gameChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a82f9a6')) {
      api.createRecord('2a82f9a6', component.options)
    } else {
      api.reload('2a82f9a6', component.options)
    }
    module.hot.accept("./gameChart.vue?vue&type=template&id=2a82f9a6&", function () {
      api.rerender('2a82f9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/gameChart.vue"
export default component.exports